<ifc-base-dialog title="Available funds"
                 (actionClicked)="onActionClicked()">
  <ng-template #content>
    <p>
      {{data?.message}}
    </p>
    <p>
      <span class="subtitle-number color-primary">{{data?.availableFunds | shortNumber:'0'}}</span>
      <span class="subtitle secondary-text"> available of </span>
      <span class="subtitle-number color-primary">{{data?.msaCreditLimit | shortNumber:'0'}}</span>
      <span class="subtitle secondary-text"> line limit</span>
    </p>
  </ng-template>
</ifc-base-dialog>
